import type { RestaurantMetadata } from '../restaurants/apiHelpers';
import { useAuth } from './AuthContext';

/**
 * Selected restaurant summary from auth ({@link RestaurantMetadata}, same shape as GET /admin/restaurants items).
 * Full detail for settings (cancellation policy, shifts, …) loads separately via `getAdminRestaurant`.
 *
 * Safe within `<IsAuthenticated />` when the admin has at least one restaurant.
 */
export const useRestaurant = (): RestaurantMetadata => {
  const { restaurants, selectedRestaurant } = useAuth();

  // Check if we have at least one restaurant associated
  if (!restaurants.length) {
    throw new Error('no restaurants available');
  }

  if (!selectedRestaurant) {
    throw new Error('selectedRestaurant is null');
  }
  return selectedRestaurant;
};
